import { FormFieldData } from "modules/forms";
import { ObservationConcernLevelEnum } from "shared/enums/ObservationConcernLevel.enum";
import { IMapper } from "shared/types/IMapper";
import { IssueByIdResponse } from "../queries/view-issue.queries.types";
import { IssueEntity } from "shared/types/domain/IssueEntity";

export class IssueEntityMapper implements IMapper<IssueByIdResponse, FormFieldData<IssueEntity>> {
    map(entity: IssueByIdResponse): FormFieldData<IssueEntity> {
        return {
            nearMissId: entity.issue.observationId,
            concernLevel: entity.issue.concernLevel as ObservationConcernLevelEnum,
            locationType: entity.issue.locationType,
            depotPcId: entity.issue.depotPcId,
            whatHappened: entity.issue.whatHappened,
            howToStop: entity.issue.howToStop,
            anonymousEntry: entity.issue.anonymousEntry,
            reporterType: entity.issue.reporterType,
            reporterContactName: entity.issue.reportedBy?.reporterContactName,
            reporterPhoneNumber: entity.issue.reportedBy?.reporterPhoneNumber,
            reporterEmail: entity.issue.reportedBy?.reporterEmail,
            incidentDate: entity.issue.incidentDate,
            processId: entity.issue.processId,
            reachId: entity.issue.reachId
        }
    }
}